// ----------------------------------------------------------------------------
// Section: Detailed Products
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_detailed-product.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--featured-product';
var CAROUSEL_CLASS = 'carousel--featured-product';
var CAROUSEL_SECTION_SELECTOR = '.product-group-cards';
var CAROUSEL_SECTION_CLASS = 'product-group-cards';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
var swiperInstances = new Map();

// -------------------------------------
// Functions
// -------------------------------------

function minimumSlides() {
  var isDesktop = window.innerWidth >= 768;
  return isDesktop ? 3 : 2;
}
function initializeCarousel(element, index) {
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 1.2,
    spaceBetween: 0,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    keyboard: true,
    controller: {
      by: 'slide'
    },
    autoplay: true,
    a11y: true,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 16
      }
    },
    pagination: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
      }
    },
    navigation: {
      nextEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-next-").concat(index),
      prevEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-prev-").concat(index)
    },
    on: {
      init() {
        removeLazyFromVisibleSlides(this);
      },
      slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
        removeLazyFromVisibleSlides(this);
      }
    }
  });
  swiperInstances.set(element, swiper);
  var paginationBullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
  paginationBullets.forEach((bullet, bulletIndex) => {
    bullet.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        swiper.slideTo(bulletIndex);
      }
    });
  });
}
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.card__main-image[loading="lazy"]');
      if (img) img.removeAttribute('loading');
    }
  });
}
function setupCarousels() {
  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
    var carousel = element.querySelector(CAROUSEL_SELECTOR);
    var slidesCount = carousel.querySelectorAll('.swiper-slide').length;
    var minSlides = minimumSlides();
    var existingSwiper = swiperInstances.get(element);

    // Clean up: remove any previous static or swiper classes
    element.classList.remove('static-slides');
    carousel.classList.remove("".concat(CAROUSEL_CLASS, "-").concat(index));
    if (slidesCount > minSlides) {
      if (!existingSwiper) {
        carousel.classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
        element.querySelectorAll(CAROUSEL_PREV_BUTTON_SELECTOR).forEach(btn => btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)));
        element.querySelectorAll(CAROUSEL_NEXT_BUTTON_SELECTOR).forEach(btn => btn.classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index)));
        element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
        initializeCarousel(element, index);
      }
    } else {
      element.classList.add('static-slides');
      if (existingSwiper) {
        existingSwiper.destroy(true, true);
        swiperInstances.delete(element);
        carousel.classList.remove("".concat(CAROUSEL_CLASS, "-").concat(index));
        element.querySelectorAll(CAROUSEL_PREV_BUTTON_SELECTOR).forEach(btn => btn.classList.remove("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)));
        element.querySelectorAll(CAROUSEL_NEXT_BUTTON_SELECTOR).forEach(btn => btn.classList.remove("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index)));
        element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.remove("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
      }
    }
  });
}

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  setupCarousels();
  window.addEventListener('resize', () => {
    setupCarousels();
  });
});